export const securityStats = {
    vulnerabilities: 1,
    secrets: 1,
    codeScanning: 1,
    total: 3
};
